import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
const defaultOptions = {} as const;

export const UpsertPricingBookmarksDocument = gql`
  mutation UpsertPricingBookmarks(
    $entries: [UpsertPricingBookmarkEntryInput!]!
  ) {
    upsertPricingBookmarks(entries: $entries) {
      bookmarks {
        bookmarked_at
        note
        restaurant_id
        variant_pack_id
      }
      upsert_count
    }
  }
`;
export type UpsertPricingBookmarksMutationFn = Apollo.MutationFunction<
  Types.UpsertPricingBookmarksMutation,
  Types.UpsertPricingBookmarksMutationVariables
>;
export function useUpsertPricingBookmarksMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpsertPricingBookmarksMutation,
    Types.UpsertPricingBookmarksMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.UpsertPricingBookmarksMutation,
    Types.UpsertPricingBookmarksMutationVariables
  >(UpsertPricingBookmarksDocument, options);
}
export type UpsertPricingBookmarksMutationHookResult = ReturnType<
  typeof useUpsertPricingBookmarksMutation
>;
export type UpsertPricingBookmarksMutationResult =
  Apollo.MutationResult<Types.UpsertPricingBookmarksMutation>;
export type UpsertPricingBookmarksMutationOptions = Apollo.BaseMutationOptions<
  Types.UpsertPricingBookmarksMutation,
  Types.UpsertPricingBookmarksMutationVariables
>;
